import React from 'react';
export const InfoModal = ({ message, onClose }: { message: string; onClose: () => void }) => {
    return (
        <div className="modal-overlay-info">
            <div className="modal-box-info">
                <div className="modal-header-info">
                    <span>Information</span>
                    <button className="close-btn-info" onClick={onClose}>×</button>
                </div>

                <div className="modal-body-info">
                    {message}
                </div>

                <div className="modal-footer-info">
                    <button className="btn-close-info" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};